// eslint-disable-next-line max-len
export default {
  authorizationCodeFormat: 'Authorization Code requires six digits',

  // eslint-disable-next-line max-len
  passwordRequirementsErrorMessage: 'Password must be eight or more characters, contain at least one upper and one lower case letter, at least one number, and at least one special character (ex. @)',

  passwordConfirmationError: "Passwords don't match",

  verificationErrorMessage: 'Something went wrong while confirming your verification code. Please try again later.'
};
